import angular from 'angular';
import billfoldComponent from './billfold.component';
import BillfoldService from './billfold.service';
import billfoldConfig from './billfold.config';

let billfoldModule = angular.module('app.reports.billfold',[])
  .component('billfold', billfoldComponent)
  .service('BillfoldService', BillfoldService)
  .config(billfoldConfig);

export default billfoldModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/billfold/billfold.js
 **/